import { NotificationPushRegistrationModel } from './notification-push-registration-model';

export class NotificationPushRegistrationInfoModel extends NotificationPushRegistrationModel {
  expirationTime: Date|null;
  eTag: string;
}
